var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingBasketFill1Wght700Grad200Opsz48(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.35 43q-1.15 0-2.05-.675-.9-.675-1.25-1.825l-5.9-20.9q-.2-1.15.425-1.975Q2.2 16.8 3.35 16.8h9.8L21.7 4q.35-.55.975-.875Q23.3 2.8 23.95 2.8q.65 0 1.275.325.625.325.975.875l8.5 12.8h10.05q1.1 0 1.75.825.65.825.4 1.975l-5.85 20.9q-.35 1.15-1.25 1.825T37.75 43ZM24 33.05q1.3 0 2.225-.925t.925-2.225q0-1.3-.925-2.225T24 26.75q-1.3 0-2.225.925T20.85 29.9q0 1.3.925 2.225T24 33.05ZM18.55 16.8h10.8L23.9 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBasketFill1Wght700Grad200Opsz48);
export default __webpack_public_path__ + "static/media/shopping_basket_FILL1_wght700_GRAD200_opsz48.18dbee76541ce018226d5b81383cf17c.svg";
export { ForwardRef as ReactComponent };